// extracted by mini-css-extract-plugin
export default {"pageWrap":"gc-z","fullWidth":"hc-z","heading":"ic-z","fullBleed":"jc-z","hidden":"kc-z"};